import { RouteRecordRaw } from 'vue-router';

const Layout = () => import('@/layout/index.vue');
const contactRouter:RouteRecordRaw =  {
    path: '/join',
    component: Layout,
    name: 'join',
    children: [
        {
            path: '',
            name: 'join-index', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/join/index.vue'),
            meta: {
                title: '加入我们'
            }
        },
        {
            path: 'recruitment',
            name: 'join-recruitment', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/join/recruitment.vue'),
            meta: {
                title: '招贤纳士'
            }
        }
    ]
};

export default contactRouter;
